'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _i18nReact = require('i18n-react');

var _i18nReact2 = _interopRequireDefault(_i18nReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var language = localStorage.getItem('vas_language') != null ? localStorage.getItem('vas_language') : 'de';
if (localStorage.getItem('vas_language') == null) {
  localStorage.setItem('vas_language', 'de');
}
var data = require('./i18n/' + language + '.json');

_i18nReact2.default.setTexts(data);

var Vas = function (_Component) {
  _inherits(Vas, _Component);

  function Vas() {
    _classCallCheck(this, Vas);

    return _possibleConstructorReturn(this, (Vas.__proto__ || Object.getPrototypeOf(Vas)).apply(this, arguments));
  }

  _createClass(Vas, null, [{
    key: 'getText',
    value: function getText(type, name) {
      return _i18nReact2.default.texts[type][name];
    }
  }]);

  return Vas;
}(_react.Component);

exports.default = Vas;